import { createSelector } from 'reselect';
import { SidebarState } from './types';

export const selectSidebarMap = (state): SidebarState => state.sidebar;

export const selectIsSidebarExpanded = createSelector(selectSidebarMap, (sidebarData) => sidebarData.isExpanded);

export const selectIsSidebarCloseButtonEnable = createSelector(
	selectSidebarMap,
	(sidebarData) => sidebarData.isCloseButtonEnable,
);
